export const isHexColor = str => /^#[0-9a-f]{3}(?:[0-9a-f]{3})?$/i.test(str);
